const DB_NAME = 'cpt-image-cache';
const DB_VERSION = 1;
const STORE_NAME = 'images';

function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;

      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = () => {
      resolve(request.result);
    };

    request.onerror = () => {
      reject(request.error);
    };
  });
}

/**
 * Get a cached image.
 */
export async function getCachedImage(key) {
  try {
    const db = await openDatabase();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, 'readonly');
      const store = transaction.objectStore(STORE_NAME);

      const request = store.get(key);

      request.onsuccess = () => {
        resolve(request.result || null);
      };
 
      request.onerror = () => {
        reject(request.error);
      };
    });
  } catch (error) {
    console.warn('Image cache read failed:', error);
    return null;
  }
}

/**
 * Save an image Blob.
 */
export async function cacheImage(key, blob, url) {
  try {
    const db = await openDatabase();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, 'readwrite');
      const store = transaction.objectStore(STORE_NAME);

      store.put(
        {
          blob: blob,
          url: url,
          cachedAt: Date.now()
        },
        key
      );

      transaction.oncomplete = () => {
        resolve(true);
      };

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  } catch (error) {
    console.warn('Image cache write failed:', error);
    return false;
  }
}

/**
 * Return a browser object URL for a cached image.
 */
export function createCachedImageUrl(cachedImage) {
  if (!cachedImage || !cachedImage.blob) {
    return null;
  }

  return URL.createObjectURL(cachedImage.blob);
}

/**
 * Download an image and cache it.
 */
export async function fetchAndCacheImage(key, url) {
  try {
    // Check IndexedDB first
    const cached = await getCachedImage(key);

    if (cached && cached.blob) {
      console.log('IMAGE CACHE HIT:', key);
      return createCachedImageUrl(cached);
    }

    console.log('IMAGE CACHE MISS:', key);

    // Proxy the SmugMug image through our server
    const proxyUrl =
      'https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' +
      encodeURIComponent(btoa(url));

    const response = await fetch(proxyUrl);

    if (!response.ok) {
      throw new Error(
        `Image request failed: ${response.status}`
      );
    }

    const blob = await response.blob();

    console.log(
      'SAVING IMAGE TO INDEXEDDB:',
      key,
      blob.size
    );

    await cacheImage(key, blob, url);

    return URL.createObjectURL(blob);

  } catch (error) {

    console.warn(
      'Could not cache image:',
      url,
      error
    );

    // Fall back to the normal SmugMug URL
    return url;
  }
}